<div class="modal-header border-0 justify-content-md-center my-3">
    <i data-test="addCalculationIcon" class="gpr-add mr-2"></i>
    <h5 data-test="addCalculationTitle">{{ 'HEADER.ADD_CALCULATION.ADD_CALCULATION' | translate }}</h5>
</div>
<form [formGroup]="saveAsCalculationForm" (ngSubmit)="saveAsCalculation()">
    <div class="modal-body mx-5 p-0">
        <mat-form-field class="w-100">
            <mat-label data-test="calculationName">{{ 'HEADER.ADD_CALCULATION.NAME' | translate }}</mat-label>
            <input data-test="nameInput" matInput appInputFocus
                   placeholder="" name="name" formControlName="name"
                   [ngClass]="{ 'is-invalid': submitted && controls.name.errors }">

            <mat-error data-test="titleErrorRequired" *ngIf="controls.name.errors && controls.name.errors.required">
                {{ 'VALIDATION_MESSAGE.ENTER_NAME' | translate }}
            </mat-error>
            <mat-error data-test="titleErrorMin" *ngIf="controls.name.errors && controls.name.errors['minlength']">
                {{ 'VALIDATION_MESSAGE.MIN_LENGTH' | translate }}
            </mat-error>
        </mat-form-field>
    </div>
    <div class="modal-footer row justify-content-center border-0 mx-5 mt-3 mb-4 p-0 action-btn-group">
        <button id="btn-confirm" data-test="addCalculationBtn" type="submit" mat-raised-button class="col w-100 mr-2 make-btn">
            {{ 'CONFIRM' | translate }} &rarr;
        </button>
        <button data-test="cancelCalculationBtn" type="button" mat-stroked-button mat-dialog-close class="col w-100 ml-2 cancel-btn">
            {{ 'CANCEL' | translate }}
        </button>
    </div>
</form>